const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/about.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
export const Route = createFileRoute("/{-$locale}/about")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  head: () => {
    return {
      meta: [{
        title: i18n.t("about.meta.title"),
        description: i18n.t("about.meta.description")
      }]
    };
  }
});